import { IDataIncluded, IKPISite } from '@interfaces/kpi/kpiCommon';

export const prepareDataIncluded = (sites: Array<IKPISite>): IDataIncluded[] => {
	const result: IDataIncluded[] = [];

	sites.forEach(item => {
		const existingTech = result.find(obj => obj.technology === item.technology);

		if (existingTech) {
			existingTech.sites.push({
				siteId: item.siteId,
				cellIds: item.cellIds,
			});
		} else {
			result.push({
				technology: item.technology,
				sites: [{
					siteId: item.siteId,
					cellIds: item.cellIds,
				}],
			});
		}
	});

	return result;
};
